<template>
    <div class="col-12 col-md-10 col-lg-8 login-wrapper py-3">
        <ValidationObserver ref="loginForm">
            <div class="row">
                <div class="col-12 mt-3">
                    <ValidationProvider name="nationalId" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('tc_or_passport')" class="input-icon position-relative">
                            <b-form-input
                                type="text"
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-mask="'###########'"
                                v-model="loginForm.nationalId"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 mt-2">
                    <ValidationProvider name="pinCode" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('pin') || 'PIN'" class="input-icon position-relative">
                            <b-form-input
                                type="password"
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-model="loginForm.pinCode"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 mt-4">
                    <b-button @click="login" block variant="primary" :disabled="loading" class="font-weight-bold">
                        <b-spinner small v-if="loading"></b-spinner>
                        <span v-else>{{ $t('login')}}</span>
                    </b-button>
                </div>
                <div class="col-12 mt-3">
                    <b-button @click="$emit('switch-to-register')" block variant="outline-primary" class="font-weight-bold">{{ $t('sign_up') }}</b-button>
                </div>
                <div class="col-12 mt-3 text-center">
                    <b-button @click="forgotPassword" variant="link" class="text-dark font-weight-bold">{{ $t('forgot_my_password') }}</b-button>
                </div>
            </div>
            <div class="row mt-5 pt-4 border-top">
                <div class="col-12 text-muted small text-center" v-html="$t('urgent_inquiries_help_text')"></div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import SpecialStudentApplicationRegisterServices from "@/services/SpecialStudentApplicationRegisterServices";
export default {
    name: "LoginComponent",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            loginForm: {
                nationalId: null,
                passportNumber: null,
                pinCode: null
            },
            loading: false
        }
    },
    methods: {
        async login() {
            const isValid = await this.$refs.loginForm.validate();
            if(isValid) {
                let payload = {
                    national_id: this.loginForm.nationalId,
                    passport_number: this.loginForm.passportNumber || null,
                    pin: this.loginForm.pinCode
                };

                SpecialStudentApplicationRegisterServices.login(payload).then(async (response) => {
                    await this.$store.dispatch('SpecialStudentApplicationRegister/setLoginData',response.data.data)
                    setTimeout(() => {
                        this.$router.push('/special-student/application/form')
                    }, 500);
                }).catch(e => {
                    this.showErrors(e,this.$refs.loginForm)
                }).finally(()=>{
                    this.loading = false;
                });
            }
        },
        forgotPassword() {
            this.$emit('forgot-password');
        }
    }
}
</script>
